import React, { useEffect, useRef, useState } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Dialog,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import FormatterChecker from "./FormatChecker";
import { useNavigate } from "react-router-dom";
import { checkUserLoggedIn } from "../shared/commonfunctions";
import {
  startOverAPICall,
  documentupdateAPICall,
  getDocumentTypeDropDownAPICall,
  stageDetailsAPICall,
  PanDocumentRequestAPICall,
  IncomeProofRequestAPICall,
  CommonDropDownAPICall,
} from "../shared/APICalls";
import routesData from "../shared/routes.json";
import uploadStyles from "../pages/Styles/Uploads.module.scss";
import SnackBar from "../Components/SnackBars/SnackBar";
import StartOverBackDrop from "../Components/StartOverBackDrop";
import SucessSnackBar from "../Components/SnackBars/SucesssnackBar";
import BackDrop from "../Components/BackDrop";
import ErrorSnackBar from "../Components/SnackBars/ErrorSnackBar";
import { UploadSizes } from "../shared/constants";
import FormatterCheckerPanFetch from "./FormatCheckerPanFetch";
import { confirmAlert } from "react-confirm-alert";

import FormatterCheckerIncomeProof from "./FormatCheckerIncomeProof";
import backicon from "../Components/assets/Images/back.svg";
import { useDispatch } from "react-redux";
import {
  setCompletedStages,
  setCurrentStage,
} from "../Components/redux/actions/pathNameActions";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import TagManager from "react-gtm-module";
import ProgressComp from "../Components/ProgressComp/ProgressComp";
import SignaturePad from "../Components/SignaturePad/SignaturePad";
import uploadsignatureicon from "../Components/assets/Images/uploadsignatureicon.svg";
import SignaturePadNew from "../Components/SignaturePad/SignaturePadNew";
import FormatterCheckerLatest from "./FormatCheckerLatest";
import SideBar from "../Components/SideBar/SideBar";
import FormatterCheckerSignature from "./FormatCheckerSignature";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import MenuIcon from "@mui/icons-material/Menu";
import ProgressBar from "../Components/ProgressBar/ProgressBar";

export default function UploadDocumentsPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setloading] = useState(false);
  const [message, setmessage] = React.useState("");
  const [infoMessage, setinfoMessage] = React.useState(true);
  const [incomeProofDropdown, setincomeProofDropdown] = useState<any>([]);
  const [incomeProofDocRef, setincomeProofDocRef] = useState<any>();
  const [signatureDocRef, setSignatureDocRef] = useState<any>();
  const [panCardDocRef, setPanCardDocRef] = useState<any>();
  const [showUpload, setShowUpload] = useState(false);
  const [disableContinueOption1, setdisableContinueOption1] = useState("");
  const [disableContinueOption2, setdisableContinueOption2] = useState("");
  const [disableContinueOption3, setdisableContinueOption3] = useState("");
  const [displayDropdownOptions, setDisplayDropdownOptions] = useState(true);
  const [incomeProofUrl, setincomeProofUrl] = useState<any>();
  const [signatureUrl, setsignatureUrl] = useState<any>();
  const [bankProofeUrl, setbankProofUrl] = useState<any>();
  const [pancardUrl, setpancardUrl] = useState<any>();
  const [IncomeProof, setIncomeProof] = useState<any>("");
  const [InformationMessage, setInformationMessage] = useState("");
  const [backdrop, setBackDrop] = useState(false);
  const rupeeSymbol = String.fromCharCode(8377);
  const [uploadmessage, setUploadmessage] = useState("");
  const [backLoading, setBackDropLoading] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");
  const [IncomeProofDocTypeRef, setIncomeProofDocTypeRef] = useState("");
  const [kraStatus, setKRAStatus] = useState({
    KraStatus: "",
  });

  const [initialdropdowndata, setinitialdropdowndata] = useState<any>([]);
  const [childWindowRef, setchildWindowRef] = useState<any>(null);
  const [closetTimer, setclosetTimer] = useState(false);
  const timerRef = useRef<any>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [fetchLodaing, setFetchLoading] = useState(false);
  const [fetchIncomeLoading, setFetchIncomeLoading] = useState(false);
  const [mobileDialogOpen, setMobileDialogOpen] = useState(false);
  const [mobileChoice, setMobileChoice] = useState("registered");
  const [alternateMobile, setAlternateMobile] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [registeredMobile, setregisteredMobile] = useState<any>(
    sessionStorage.getItem("mobile") || "",
  );
  // const registeredMobile = sessionStorage.getItem("mobile") || "";
  const [errorMessage, seterrorMessage] = useState("");
  const [previewImageLoading, setpreviewImageLoading] = useState(false);
  const [drawPad, setDrawPad] = useState(false);
  const [expandMenu, setExpandMenu] = useState<any>(false);
  const [selectedFileSignature, setSelectedFileSignature] =
    useState<File | null>(null);

  const navigationData = routesData;

  const chequeFormat = ["png", "jpg", "jpeg"];
  const formats = ["pdf", "png", "jpg", "jpeg"];

  useEffect(() => {
    window.scrollTo(0, 0);
    checkUserLoggedIn(navigate);
    StageDetailsInitial();
  }, []);
  useEffect(() => {
    if (!closetTimer && childWindowRef) {
      //  console.log("timer trigger");
      timerRef.current = setInterval(checkChild, 500);
    }

    return () => {
      clearInterval(timerRef.current);
    };
  }, [childWindowRef, closetTimer]);

  const handleChange = (event: any) => {
    setIncomeProofDocTypeRef(event.target.value.document_type_reference);
    // console.log(event.target.value);

    setIncomeProof(event.target.value);
    setincomeProofDocRef(event.target.value.purpose);

    setShowUpload(true);

    switch (event.target.value.value) {
      case "Copy of ITR acknowledgement":
        setInformationMessage(
          `ITR acknowledgment with gross annual income exceeding ${rupeeSymbol}1,20,000`,
        );
        break;
      case "Salary Slip for last 3 months":
        setInformationMessage(
          `The latest salary slip with gross monthly income exceeding ${rupeeSymbol}15,000`,
        );
        break;
      case "Copy of Form 16 in case of salary income":
        setInformationMessage(
          `Form 16 with gross annual income exceeding ${rupeeSymbol}1,20,000`,
        );
        break;
      case "Copy of cancelled cheque":
        setInformationMessage(`Copy of cancelled cheque of your bank account`);
        break;
      case "Bank account statement for last 6 month":
        setInformationMessage(
          `Bank statement for the last 6 months with average balance of more than ${rupeeSymbol}10,000`,
        );
        break;
    }
  };
  const handleClick = () => {
    handleStageAPI();
  };

  const handleStartOver = () => {
    confirmAlert({
      title: "",
      message:
        "Are you sure you want to restart, on pressing Yes all the Data will be deleted",
      buttons: [
        {
          label: "No",
          onClick: () => "",
        },
        {
          label: "Yes",
          onClick: () => {
            setBackDrop(true);
            startOverAPICall()
              .then((response: any) => {
                const responseData = response.data;
                // console.log("responseData", response);
                setBackDrop(false);
                navigate("/");
                window.location.reload();
              })
              .catch((error: any) => {
                setBackDrop(false);
              });
          },
        },
      ],
    });
  };

  const handleStageAPI = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: "formSubmitUploadDocuments",
      },
    });
    setloading(true);
    documentupdateAPICall()
      .then((response: any) => {
        const responseData = response.data;
        // console.log("responseData", response);
        setloading(false);
        if (
          responseData.data.next_stage &&
          navigationData.hasOwnProperty(responseData.data.next_stage)
        ) {
          navigate(navigationData[responseData.data.next_stage]);
        }
      })
      .catch((error: any) => {
        setloading(false);
        if (error.response.data.message) {
        }
        seterrorMessage(error.response.data.message);
        setTimeout(() => {
          seterrorMessage("");
        }, 5000);
      });
  };

  const handlePreview = (data: any) => {
    //console.log(data);
  };

  const handleDisplayOptions = (data: any) => {
    setDisplayDropdownOptions(data);
    if (data === true) {
      setIncomeProof("");
      setIncomeProof(initialdropdowndata[0]);

      setIncomeProofDocTypeRef(initialdropdowndata[0].document_type_reference);
      setincomeProofDocRef(initialdropdowndata[0].purpose);
      // setShowUpload(false);
      setincomeProofUrl("");
      setInformationMessage("");
    }
  };

  function checkChild() {
    // console.log("timer");

    if (childWindowRef && childWindowRef.closed) {
      clearInterval(timerRef.current);
      StageDetailsInitial();
      setFetchLoading(false);
      setFetchIncomeLoading(false);
    }
  }

  const handleOpenClick = () => {
    setFetchLoading(true);
    let digilink: string = "";
    let obj: any = {
      digi_redirect_type: "pancr",
    };

    PanDocumentRequestAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;

        // console.log("responseData", responseData.data);
        digilink = responseData.data.link;

        window.location.href = digilink;
        // setTimeout(() => {
        //   const childWindow: any = window.open(
        //     digilink,
        //     "_blank",
        //     "width=500,height=700"
        //   );
        //   setchildWindowRef(childWindow);
        // });
      })
      .catch((error: any) => {
        setFetchLoading(false);
      });
  };
  const handleOpenClickIncomeProof = () => {
    setMobileChoice("registered");
    setAlternateMobile("");
    setMobileError("");
    setMobileDialogOpen(true);
  };

  const handleVerifyIncomeProof = () => {
    if (fetchIncomeLoading) return;
    if (mobileChoice === "different" && !/^[6-9]\d{9}$/.test(alternateMobile)) {
      setMobileError("Enter a valid 10-digit mobile number.");
      return;
    }
    setMobileError("");
    setFetchIncomeLoading(true);
    let digilink: string = "";

    IncomeProofRequestAPICall(
      mobileChoice === "different"
        ? { mobile_number: alternateMobile }
        : { mobile_number: registeredMobile },
    )
      .then((response: any) => {
        const responseData = response.data;

        // console.log("responseData", responseData.data.link);
        digilink = responseData.data.link;

        window.location.href = digilink;
        // setTimeout(() => {
        //   const childWindow: any = window.open(
        //     digilink,
        //     "_blank",
        //     "width=500,height=700"
        //   );
        //   setchildWindowRef(childWindow);
        // });
      })
      .catch((error: any) => {
        setFetchIncomeLoading(false);
        if (error.response.data.message) {
          seterrorMessage(error.response.data.message);
          setTimeout(() => {
            seterrorMessage("");
          }, 5000);
        }

        setMobileError("Unable to start verification. Please try again.");
      });
  };

  const StageDetailsInitial = () => {
    let dropDowndata: any;
    setBackDropLoading(true);
    let dd_type = "document_type";
    CommonDropDownAPICall(dd_type)
      .then((response: any) => {
        const responseData = response.data;

        const incomeProofdata = responseData?.data?.income_proof;
        const filtredData = incomeProofdata.sort(
          (a: any, b: any) => a.sequence - b.sequence,
        );
        setIncomeProof(filtredData[0]);
        setinitialdropdowndata(filtredData);
        setIncomeProofDocTypeRef(filtredData[0]?.document_type_reference);
        setincomeProofDocRef(filtredData[0]?.purpose);
        setShowUpload(true);
        setincomeProofDropdown(filtredData);
        dropDowndata = responseData?.data?.income_proof;
        setSignatureDocRef(responseData?.data?.signature?.docTypeRef);
        setPanCardDocRef(responseData?.data?.pancard?.docTypeRef);
        setincomeProofDocRef(responseData?.data?.income_proof[0]?.purpose);
      })
      .catch((error: any) => {});
    let obj: any = {
      stage: "document_upload",
    };

    stageDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;

        dispatch(setCompletedStages(responseData?.data?.completed_stages));
        dispatch(setCurrentStage(responseData?.data?.current_stage));
        if (responseData.data.ErrorMessage) {
          setRejectMessage(responseData.data.ErrorMessage);
        }
        if (responseData?.data?.data?.mobile_number) {
          setregisteredMobile(responseData?.data?.data?.mobile_number);
        }

        if (responseData?.data?.data?.kra_status) {
          setKRAStatus({
            KraStatus: responseData?.data?.data?.kra_status,
          });
        }

        setBackDropLoading(false);

        // console.log(
        //   "responseData?.data?.data",
        //   responseData?.data?.data["is_f&o_selected"],
        // );

        if (responseData?.data?.data["is_f&o_selected"] === true) {
          setinfoMessage(true);
          setdisableContinueOption3("");
        } else {
          setinfoMessage(false);
          setdisableContinueOption3("Document uploaded successfully.");
        }

        if (responseData?.data?.data?.income_proof?.url) {
          setdisableContinueOption3("Document uploaded successfully.");
        }
        if (responseData?.data?.data?.signature?.url) {
          setdisableContinueOption1("Document uploaded successfully.");
        }
        if (responseData?.data?.data?.pancard?.url) {
          setdisableContinueOption2("Document uploaded successfully.");
        }

        if (
          responseData?.data?.data?.pancard &&
          responseData?.data?.data?.pancard?.url
        ) {
          setpancardUrl(responseData?.data?.data?.pancard?.url);
        }

        if (
          responseData?.data?.data?.signature &&
          responseData?.data?.data?.signature?.url
        ) {
          setsignatureUrl(responseData?.data?.data?.signature?.url);
        }
        if (
          responseData?.data?.data?.bank_proof &&
          responseData?.data?.data?.bank_proof?.url
        ) {
          setbankProofUrl(responseData?.data?.data?.bank_proof?.url);
        }

        if (
          responseData?.data?.data?.income_proof &&
          responseData?.data?.data?.income_proof?.url
        ) {
          setShowUpload(true);
          setDisplayDropdownOptions(false);
          setincomeProofUrl(responseData?.data?.data?.income_proof?.url);
        }

        if (
          dropDowndata &&
          responseData?.data?.data?.income_proof?.docTypeRef
        ) {
          const SetSelectData = dropDowndata.find(
            (item) =>
              item.document_type_reference ===
              responseData?.data?.data?.income_proof?.docTypeRef,
          );

          setIncomeProof(SetSelectData);
        }
      })
      .catch((error: any) => {
        // console.log("error", error);
        setBackDropLoading(false);
      });
  };

  const handleSignatureDocumentID = (data: any) => {
    // console.log("dataSignature", data);

    setdisableContinueOption1(data);
    if (data === "") {
      setsignatureUrl("");
    }

    setUploadmessage(data);
    setTimeout(() => {
      setUploadmessage("");
    }, 5000);
  };

  const handlePanDocumentID = (data: any) => {
    // console.log("panCradData", data);
    setdisableContinueOption2(data);
    if (data === "") {
      setpancardUrl("");
      setSelectedFile(null);
    }

    setUploadmessage(data);
    setTimeout(() => {
      setUploadmessage("");
    }, 5000);
  };

  const dataArray: any[] = [];
  const handleDocumentID = (data: any) => {
    // console.log("documentID", data);
    setdisableContinueOption3(data);

    setUploadmessage(data);

    setTimeout(() => {
      setUploadmessage("");
    }, 5000);
  };

  // console.log(
  //   "selectedFileSignature",
  //   selectedFileSignature,
  //   "signatureurl",
  //   signatureUrl,
  // );

  return (
    <>
      <Dialog
        open={mobileDialogOpen}
        onClose={() => !fetchIncomeLoading && setMobileDialogOpen(false)}
        aria-labelledby="verify-mobile-title"
        aria-describedby="verify-mobile-description"
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            borderRadius: "14px",
            margin: "16px",
            width: "calc(100% - 32px)",
          },
        }}
      >
        <form
          className={uploadStyles.mobileVerification}
          onSubmit={(event) => {
            event.preventDefault();
            handleVerifyIncomeProof();
          }}
        >
          <h2 id="verify-mobile-title">Verify your mobile number</h2>
          <p id="verify-mobile-description">
            Choose a mobile number for income verification
          </p>
          <div
            className={uploadStyles.mobileOptions}
            role="radiogroup"
            aria-label="Mobile number for income verification"
          >
            <div>
              <label className={uploadStyles.mobileOption}>
                <input
                  type="radio"
                  name="verificationMobile"
                  value="registered"
                  checked={mobileChoice === "registered"}
                  disabled={fetchIncomeLoading}
                  onChange={() => {
                    setMobileChoice("registered");
                    setMobileError("");
                  }}
                />
                <span>Use My Registered Mobile Number</span>
              </label>
              <div className={uploadStyles.registeredMobile}>
                <span>
                  {registeredMobile
                    ? `+91 ${registeredMobile}`
                    : "Registered mobile number"}
                </span>
                <span className={uploadStyles.registeredBadge}>Registered</span>
              </div>
            </div>
            <div>
              <label className={uploadStyles.mobileOption}>
                <input
                  type="radio"
                  name="verificationMobile"
                  value="different"
                  checked={mobileChoice === "different"}
                  disabled={fetchIncomeLoading}
                  onChange={() => {
                    setMobileChoice("different");
                    setMobileError("");
                  }}
                />
                <span>Use a different mobile number</span>
              </label>
              <input
                className={uploadStyles.alternateMobile}
                aria-label="Different mobile number"
                aria-invalid={mobileChoice === "different" && !!mobileError}
                aria-describedby={
                  mobileError ? "verification-mobile-error" : undefined
                }
                type="tel"
                inputMode="numeric"
                autoComplete="tel-national"
                maxLength={10}
                placeholder="Enter your mobile number"
                disabled={fetchIncomeLoading}
                value={alternateMobile}
                onFocus={() => {
                  setMobileChoice("different");
                  setMobileError("");
                }}
                onChange={(event) => {
                  setAlternateMobile(
                    event.target.value.replace(/\D/g, "").slice(0, 10),
                  );
                  setMobileError("");
                }}
              />
            </div>
          </div>
          {mobileError && (
            <p
              id="verification-mobile-error"
              className={uploadStyles.mobileError}
              role="alert"
            >
              {mobileError}
            </p>
          )}
          <div className={uploadStyles.mobileActions}>
            <Button
              variant="outlined"
              disabled={fetchIncomeLoading}
              onClick={() => setMobileDialogOpen(false)}
            >
              Cancel
            </Button>
            <LoadingButton
              type="submit"
              variant="contained"
              loading={fetchIncomeLoading}
            >
              Continue
            </LoadingButton>
          </div>
        </form>
      </Dialog>
      <SnackBar message={message} />
      {backdrop && <StartOverBackDrop />}
      <div className={uploadStyles.layout}>
        <div className={uploadStyles.sidebar}>
          <SideBar />
        </div>
        <div className={uploadStyles.pageContent}>
          <div className={uploadStyles.mainWrapperTop}>
            <SnackBar message={errorMessage} />
            <ErrorSnackBar message={rejectMessage} />
            <SucessSnackBar message={uploadmessage} />

            <div className={uploadStyles.wrapper}>
              <div className={uploadStyles.headerSection}>
                <p className={uploadStyles.signup}>
                  <div
                    className={uploadStyles.mobileBack}
                    onClick={() => {
                      navigate("/tradingPreference");
                    }}
                  >
                    <ArrowBackIosIcon />
                  </div>
                  Upload Documents
                  <div
                    className={uploadStyles.mobileMenu}
                    onClick={() => {
                      setExpandMenu(!expandMenu);
                    }}
                  >
                    {expandMenu ? <CloseIcon /> : <MenuIcon />}
                  </div>
                </p>
                <ProgressBar />
                <div
                  className={uploadStyles.mobileexpandedMenu}
                  style={{
                    height: expandMenu ? "100%" : "0%",
                  }}
                >
                  <div className={uploadStyles.mobilemenuContent}>
                    <SideBar />
                  </div>
                </div>
                <p className={uploadStyles.subText}>
                  Make sure you upload a high-resolution image
                </p>
              </div>
              <div className={uploadStyles.contentWrapper}>
                {!backLoading ? (
                  <div className={uploadStyles.uploadAreaContainer}>
                    <div className={uploadStyles.incomePanSection}>
                      {infoMessage && (
                        <div className={uploadStyles.uploadContainer}>
                          <div className={uploadStyles.uploadLabel}>
                            Income Proof{" "}
                            {!infoMessage
                              ? "(Optional)"
                              : disableContinueOption3 !== ""
                                ? "Uploaded"
                                : ""}
                          </div>

                          <>
                            <div className={uploadStyles.uploadSection}>
                              <div className={uploadStyles.selectWrap}>
                                <FormControl style={{ width: "100%" }}>
                                  <Select
                                    className={
                                      uploadStyles.uploadSectionSelectDropDown
                                    }
                                    disableUnderline
                                    IconComponent={(props) => (
                                      <KeyboardArrowDownIcon
                                        style={{
                                          color: "var(--ds-text-primary)",
                                        }}
                                        {...props}
                                      />
                                    )}
                                    sx={{
                                      boxShadow: "none",
                                      ".MuiOutlinedInput-notchedOutline": {
                                        border: 0,
                                      },
                                      "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                                        {
                                          border: 0,
                                        },
                                      "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                                        {
                                          border: 0,
                                        },
                                      "&.MuiOutlinedInput-root.Mui-disabled": {
                                        backgroundColor:
                                          "transparent !important",
                                        opacity: 0.6,
                                      },

                                      "& .MuiSelect-select.Mui-disabled": {
                                        backgroundColor:
                                          "transparent !important",
                                        WebkitTextFillColor:
                                          "var(--ds-text-secondary)", // keeps text color
                                      },
                                      fieldset: {
                                        borderColor: "var(--ds-outline)",
                                        borderRadius: "100px",
                                        // height: "60px",
                                      },
                                      color: "var(--ds-text-primary)",
                                      fontSize: "14px",
                                    }}
                                    MenuProps={{
                                      PaperProps: {
                                        sx: {
                                          borderRadius: "10px",
                                          "& li.Mui-selected": {
                                            backgroundColor:
                                              "var(--ds-text-primary)",
                                            color: "white",
                                          },
                                        },
                                      },
                                      MenuListProps: {
                                        sx: {
                                          "& .MuiPaper-root": {
                                            borderRadius: "10px",
                                          },

                                          "& li.Mui-selected": {
                                            backgroundColor:
                                              "var(--ds-text-secondary)",
                                            color: "white",
                                            "&:hover": {
                                              backgroundColor:
                                                "var(--ds-text-secondary)",
                                              color: "white",
                                            },
                                          },
                                        },
                                      },
                                    }}
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={IncomeProof}
                                    label="Select Proof Type"
                                    onChange={handleChange}
                                    disabled={displayDropdownOptions === false}
                                  >
                                    {incomeProofDropdown.map(
                                      (data: any, index: any) => {
                                        // console.log(data)
                                        return (
                                          <MenuItem
                                            value={data}
                                            key={index}
                                            sx={{
                                              fontSize: {
                                                xs: "13px",
                                                sm: "16px",
                                              },
                                            }}
                                          >
                                            {data.value}
                                          </MenuItem>
                                        );
                                      },
                                    )}
                                  </Select>
                                </FormControl>
                              </div>

                              <div className={uploadStyles.buttonssectionpan}>
                                <div className={uploadStyles.desktopverify}>
                                  {IncomeProof?.value ===
                                    "Bank account statement for last 6 months" &&
                                    disableContinueOption3 !==
                                      "Document uploaded successfully." &&
                                    !incomeProofUrl && (
                                      <LoadingButton
                                        variant="text"
                                        component="label"
                                        size="small"
                                        sx={{
                                          display: "flex",
                                          width: "100px",
                                          height: "max-content",
                                          color: "#3263E5",
                                          borderLeft:
                                            "1px solid var(--ds-outline)",
                                          borderRadius: "0px",
                                          boxShadow: "none",
                                          fontSize: "12px",
                                          padding: "0px 10px",
                                        }}
                                        onClick={handleOpenClickIncomeProof}
                                        loading={fetchIncomeLoading}
                                      >
                                        Verify Online
                                      </LoadingButton>
                                    )}
                                </div>

                                <>
                                  {" "}
                                  {showUpload ? (
                                    <FormatterCheckerIncomeProof
                                      previewImage={handlePreview}
                                      acceptedFormats={formats}
                                      documentRef={"income_proof"}
                                      documentID={handleDocumentID}
                                      displayOptions={handleDisplayOptions}
                                      stageDetailsData={incomeProofUrl}
                                      name="incomeproof"
                                      purpose={IncomeProofDocTypeRef}
                                      pdfSize={7.5}
                                      imageSize={7.5}
                                    />
                                  ) : (
                                    <LoadingButton
                                      variant="contained"
                                      component="label"
                                      disabled
                                      sx={{
                                        display: "flex",
                                        flexDirection: {
                                          xs: "column-reverse",
                                          sm: "row",
                                        },
                                        height: "35px",
                                        color: "white",
                                        borderRadius: "20px",
                                        boxShadow: "none",
                                        fontSize: "12px",
                                        background: "#3263E5",
                                        "&:hover": {
                                          background: "#3263E5",
                                        },
                                      }}
                                    >
                                      <span>Upload</span>{" "}
                                      {/* <img
                                src={
                                  isMobile ? uploadblueicon : uploadwhiteicon
                                }
                                width={"20px"}
                              /> */}
                                    </LoadingButton>
                                  )}{" "}
                                </>
                              </div>
                            </div>
                            <div className={uploadStyles.desktopMobile}>
                              {IncomeProof?.value ===
                                "Bank account statement for last 6 months" &&
                                disableContinueOption3 !==
                                  "Document uploaded successfully." &&
                                !incomeProofUrl && (
                                  <>
                                    {" "}
                                    <span>Click Here to</span>
                                    <LoadingButton
                                      variant="text"
                                      component="label"
                                      size="small"
                                      sx={{
                                        display: "flex",
                                        // width: "100px",
                                        minHeight: "20px",
                                        height: "max-content !important",
                                        color: "#3263E5",

                                        borderRadius: "0px",
                                        boxShadow: "none",
                                        fontSize: "12px",
                                        padding: "0px 0px !important",
                                        textDecoration: "underline",
                                      }}
                                      onClick={handleOpenClickIncomeProof}
                                      loading={fetchIncomeLoading}
                                    >
                                      Verify Online
                                    </LoadingButton>{" "}
                                  </>
                                )}
                            </div>
                          </>
                          {/* )} */}
                        </div>
                      )}
                      <div className={uploadStyles.uploadContainer}>
                        <div className={uploadStyles.uploadLabel}>PAN Card</div>
                        <div className={uploadStyles.uploadPanFetchSection}>
                          <div>
                            <p className={uploadStyles.subText}>
                              Pan Card{" "}
                              {disableContinueOption2 !== ""
                                ? "Uploaded"
                                : ""}{" "}
                            </p>
                          </div>
                          <div className={uploadStyles.buttonssectionpan}>
                            {!selectedFile &&
                              !pancardUrl &&
                              kraStatus.KraStatus === "KRA_EXISTING" && (
                                <LoadingButton
                                  loading={fetchLodaing}
                                  variant="text"
                                  component="label"
                                  size="small"
                                  sx={{
                                    display: "flex",
                                    width: "100px",
                                    height: "max-content",
                                    color: "#3263E5",
                                    borderLeft: "1px solid #D5D7DA",
                                    borderRadius: "0px",
                                    boxShadow: "none",
                                    fontSize: "12px",
                                    padding: "0px 10px",
                                  }}
                                  onClick={handleOpenClick}
                                >
                                  Digilocker
                                </LoadingButton>
                              )}
                            {!selectedFile &&
                              !pancardUrl &&
                              kraStatus.KraStatus === "KRA_EXISTING" && (
                                <span style={{ fontSize: "9px" }}>|</span>
                              )}
                            <FormatterCheckerPanFetch
                              previewImage={handlePreview}
                              acceptedFormats={formats}
                              documentRef={"pancard"}
                              documentID={handlePanDocumentID}
                              displayOptions={""}
                              stageDetailsData={pancardUrl}
                              name="pancard"
                              purpose={"pancard"}
                              pdfSize={UploadSizes["pancard"].pdfSize}
                              imageSize={UploadSizes["pancard"].imageSize}
                              selectedFile={selectedFile}
                              setSelectedFile={setSelectedFile}
                              setpancardUrl={setpancardUrl}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className={uploadStyles.uploadContainerSignature}>
                      <div className={uploadStyles.uploadSignatureSection}>
                        <div
                          className={uploadStyles.uploadSignatureSectionLeft}
                        >
                          <img
                            src={uploadsignatureicon}
                            alt=""
                            className={uploadStyles.uploadsigledtimg}
                          />
                          <div>
                            <p className={uploadStyles.titletext}>
                              {" "}
                              Use the pad to sign (or) Upload manually
                            </p>
                            <p className={uploadStyles.titletextMobile}>
                              {" "}
                              Sign here or upload signature
                            </p>
                            <p className={uploadStyles.desctext}>
                              {" "}
                              This will be displayed on your profile.
                            </p>
                          </div>
                        </div>
                        <div className={uploadStyles.buttonssectionpan}>
                          {signatureUrl ? (
                            <FormatterCheckerLatest
                              previewImage={handlePreview}
                              acceptedFormats={formats}
                              documentRef={"signature"}
                              documentID={handleSignatureDocumentID}
                              displayOptions={""}
                              stageDetailsData={signatureUrl}
                              name="signature"
                              purpose={"signature"}
                              pdfSize={UploadSizes["signature"].pdfSize}
                              imageSize={UploadSizes["signature"].imageSize}
                              selectedFile={selectedFileSignature}
                              setSelectedFile={setSelectedFileSignature}
                            />
                          ) : (
                            <FormatterCheckerSignature
                              previewImage={handlePreview}
                              acceptedFormats={formats}
                              documentRef={"signature"}
                              documentID={handleSignatureDocumentID}
                              displayOptions={""}
                              stageDetailsData={signatureUrl}
                              name="signature"
                              purpose={"signature"}
                              pdfSize={UploadSizes["signature"].pdfSize}
                              imageSize={UploadSizes["signature"].imageSize}
                              selectedFile={selectedFile}
                              setSelectedFile={setSelectedFile}
                              setsignatureUrl={setsignatureUrl}
                            />
                          )}
                        </div>
                      </div>
                    </div>

                    <div className={uploadStyles.signatureAndPan}>
                      <div>
                        <SignaturePadNew
                          setDrawPad={setDrawPad}
                          purpose={"signature"}
                          documentRef={"signature"}
                          previewImageLoading={previewImageLoading}
                          setpreviewImageLoading={setpreviewImageLoading}
                          documentID={handleSignatureDocumentID}
                          setsignatureUrl={setsignatureUrl}
                          handlePreview={handlePreview}
                          formats={formats}
                          handleSignatureDocumentID={handleSignatureDocumentID}
                          signatureUrl={signatureUrl}
                          UploadSizes={UploadSizes}
                          selectedFile={selectedFileSignature}
                          setSelectedFile={setSelectedFileSignature}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div style={{ height: "65vh" }}>
                    <BackDrop />
                  </div>
                )}
              </div>
              <div className={uploadStyles.buttonStack}>
                <div className={uploadStyles.buttonSectionRight}>
                  <Button
                    variant="text"
                    sx={{
                      color: "var(--ds-text-primary)",
                      gap: "8px",
                    }}
                    onClick={() => {
                      navigate("/tradingPreference");
                    }}
                    className={uploadStyles.backbutton}
                  >
                    <KeyboardBackspaceIcon /> Back
                  </Button>
                  {disableContinueOption1 ===
                    "Document uploaded successfully." &&
                  disableContinueOption2 ===
                    "Document uploaded successfully." &&
                  disableContinueOption3 ===
                    "Document uploaded successfully." ? (
                    <LoadingButton
                      variant="contained"
                      onClick={handleClick}
                      loading={loading}
                      id="upLoadDocumentsContinueButton"
                      className={uploadStyles.approveButton}
                    >
                      {" "}
                      Continue
                    </LoadingButton>
                  ) : (
                    <LoadingButton
                      variant="contained"
                      onClick={handleClick}
                      loading={loading}
                      disabled
                      id="upLoadDocumentsContinueButton"
                      className={uploadStyles.approveButton}
                    >
                      {" "}
                      Continue
                    </LoadingButton>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
